module.exports = require('./helpers/bundle-url').getBundleURL('dUBYF') + "logo.c51670a8.svg";